module.exports = __webpack_public_path__ + "img/header_logo.cbca9485.png";